import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { store } from '../../../testStore';
import { TextInput } from '../../../lib/components/textInput';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* Result */
import Result from 'iotera-base/result';

/* Json */
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';
import { isEmpty } from 'iotera-base/object';

/* Routes */
import { domainIsTenant as dit, S } from '../../../routes/routes';

/* Redux */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

/* Sagas Actions */
import { buildWBoundActions } from '../../../redux/ducks';
import { actions as notificationActions } from '../../../redux/ducks/notification';

import { IoteraForm } from '../../../lib/components/form';
import { SubViewHeaderStep } from '../../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from '../../../lib/components/callbackGlobal';
import { _TE } from 'iotera-base/text';

const SUBMIT_DEVICE = 'SUBMIT_DEVICE';
const WKEY = 'DEVICE_ACTIVATION';
const wBoundActions = buildWBoundActions(WKEY);

const onError = errors =>
  console.log('Ada', errors.length, 'error yang harus diperbaiki');

function schema() {
  return {
    type: 'object',
    required: ['imou_device_id', 'imou_application_id'],
    properties: {
      imou_device_id: { type: 'string', minLength: 1 },
      imou_application_id: { type: 'string', minLength: 1 },
    },
  };
}

const uiSchema = {
  imou_device_id: {
    'ui:widget': props => {
      return (
        <TextInput
          id="imou_device_id"
          type="text"
          label="Imou Device Id"
          placeholder="Imou Device Id"
          textTooltip="Masukkan Imou Device Id"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      );
    },
    'ui:options': {
      label: false,
    },
  },
  imou_application_id: {
    'ui:widget': props => {
      return (
        <TextInput
          id="imou_application_id"
          type="text"
          label="Imou Application Id"
          placeholder="Imou Application Id"
          textTooltip="Masukkan Imou Application Id"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      );
    },
    'ui:options': {
      label: false,
    },
  },
};

function buildCheckConfig(self) {
  const props = self.props;
  const isTenant = dit(props);

  const wcallback = {
    started: function (id) {},
    finished: function (id, result) {
      if (result.code === Result.HTTP.OK) {
        self.goBack();
        props.showSingleNotification({ message: 'Sukses' });
      } else {
        props.showSingleNotification({ message: 'Gagal' });
      }
      self.setState({
        loading: false,
      });
    },
  };

  return {
    single_config: {
      [SUBMIT_DEVICE]: {
        wparam: {
          ...isTenant,
          method: 'POST',
          path: '/service/web/device/imouc/add',
          timeout: 60000,
        },
        wcallback,
      },
    },
  };
}

class Example extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
      loading: false,
      isDisabled: false,
    };
    this.toggle = this.toggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // callback global
    setCallbackGlobal(this.props);
    this.props.wSetConfig(buildCheckConfig(this));
  }

  componentWillUnmount() {
    const _props = this.props;
    // callback global
    unsetCallbackGlobal(_props);
    _props.wUnsetConfig({ key: WKEY });
  }

  toggle(tab) {
    const _this = this;
    const _state = _this.state;
    if (_state.activeTab !== tab) {
      _this.setState({
        activeTab: tab,
      });
    }
  }

  myFunction() {
    let x = document.getElementById('myDIV');
    if (x.style.display === 'none') {
      x.style.display = 'block';
    } else {
      x.style.display = 'none';
    }
    let y = document.getElementById('divMy');
    if (y.style.display === 'none') {
      y.style.display = 'block';
    } else {
      y.style.display = 'none';
    }
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const { isDisabled } = _state;
    let storeValue = store.getState();
    let dataToShow = storeValue;
    let dataToSubmit = event.formData;
    const imou_device_id = safeDeepGetWithType(
      event,
      ['formData', 'imou_device_id'],
      '',
    );
    const imou_application_id = safeDeepGetWithType(
      event,
      ['formData', 'imou_application_id'],
      '',
    );

    const value = {
      imou_device_id,
      imou_application_id,
    };

    dataToSubmit = {
      ...dataToShow.device,
      ...value,
    };

    if (isDisabled) {
    } else {
      _props.wSingleRequestCall({
        id: SUBMIT_DEVICE,
        body: dataToSubmit,
      });
      this.setState({
        isDisabled: true,
      });
    }
  }

  goBack() {
    this.props.history.push('..' + S + '..' + S + '_device_list_');
  }

  render() {
    const self = this;
    const props = self.props;
    const state = self.state;
    let storeValue = store.getState();
    let dataToShow = storeValue;

    if (isEmpty(dataToShow)) {
      self.goBack();
    } else {
      if ('device' in dataToShow) {
        if (isEmpty(dataToShow.device)) {
          self.goBack();
        } else {
          dataToShow = dataToShow.device;
        }
      } else {
        self.goBack();
      }
    }
    const { isDisabled, loading } = state;
    const spinner = (
      <div className="centeringItem">
        <ReactLoading type="bubbles" color="#ffffff" />
      </div>
    );
    return (
      <Loader show={loading} message={spinner}>
        <div className="view">
          <SubViewHeaderStep
            title="Tambah Perangkat"
            subTitle="Permohonan tambah perangkat Imou Camera"
            steps={['Kategori', 'Informasi', 'Aktivasi']}
            activeStep={2}
          />
          <div className="io-container mt-12">
            <IoteraForm
              schema={schema()}
              uiSchema={uiSchema}
              onSubmit={self.handleSubmit}
              formData={dataToShow}
            >
              {isDisabled ? (
                <div className="button-right" style={{ marginTop: 10 }}></div>
              ) : (
                <div className="button-right" style={{ marginTop: 10 }}>
                  <Button
                    variant="outlined"
                    size="large"
                    style={{ minWidth: '0%' }}
                    onClick={props.history.goBack}
                  >
                    Kembali
                  </Button>
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    type="submit"
                    style={{ marginLeft: 10, minWidth: '0%' }}
                  >
                    Simpan
                  </Button>
                </div>
              )}
            </IoteraForm>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(withRouter(Example));
